module.exports = __webpack_public_path__ + "static/media/mySql.cc28ccb3.svg";